var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.iconFormat(_vm.item),"alt":"","srcset":""}})]),_c('span',{class:['text', { length_6: _vm.item.name.length === 6 }]},[_vm._v(_vm._s(_vm.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }